const LINE_STYLES = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'];
function isBorderStyle(value) {
  return LINE_STYLES.includes(value);
}

export { isBorderStyle };
//# sourceMappingURL=utils.esm.js.map
